import { TabsDesignTokens } from '@primeuix/themes/types/tabs';

export const ezTabsThemeConfig: TabsDesignTokens = {
  colorScheme: {
    light: {
      tab: {
        activeColor: '#002F36',
        activeBorderColor: '#002F36',
      },
      activeBar: {
        background: '#002F36',
      },
    },
  },
};
